package one.healthium.domain.paywall.models

import kotlinx.serialization.Contextual
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonNames
import one.healthium.domain.common.Color
import one.healthium.domain.common.CtaConfig

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@SerialName("purchase_button")
data class PaywallPurchaseButtonView(
    @JsonNames("id") override val id: String,
    @SerialName("config") val config: PurchaseButtonConfig,
) : PaywallScreenView

@Serializable
data class PurchaseButtonConfig(
    @SerialName("attributed_lines") val attributedLines: List<AttributedLine> = emptyList(),
    @SerialName("height") val height: Int,
    @SerialName("style") val style: String,
    @SerialName("animation_key") val animationKey: String,
    @SerialName("background_color") @Contextual val backgroundColor: Color,
) {
    val ctaConfig = CtaConfig(
        height = height,
        style = style,
        animationKey = animationKey,
        backgroundColor = backgroundColor,
    )
}